import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { autocompleteRestaurant } from "@/graphql/queries";
import { create } from "zustand";
import type { State } from "@/types/common";
import type { RestaurantAutocompleteResult } from "@/API";
import type { GraphQLError } from "graphql";

const client = generateClient();

export const autoCompleteRestaurantState = create<
  State<RestaurantAutocompleteResult[]>
>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const autoCompleteRestaurantIsloading = () =>
  autoCompleteRestaurantState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const autoCompleteRestaurantIsError = (error: GraphQLError[]) =>
  autoCompleteRestaurantState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const autoCompleteRestaurantIsSuccess = (
  queryResult: RestaurantAutocompleteResult[],
) =>
  autoCompleteRestaurantState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
  }));

export type searchForAutoCompleteRestaurantParams = {
  search: string;
};

export const searchForAutoCompleteRestaurant = async ({
  search,
}: searchForAutoCompleteRestaurantParams) => {
  autoCompleteRestaurantIsloading();

  try {
    const { data } = await client.graphql({
      query: autocompleteRestaurant,
      variables: {
        value: search,
      },
    });

    autoCompleteRestaurantIsSuccess(
      data.autocompleteRestaurant as RestaurantAutocompleteResult[],
    );
  } catch (e: unknown) {
    const graphQl = e as GraphQLResult<RestaurantAutocompleteResult>;
    autoCompleteRestaurantIsError(graphQl.errors as GraphQLError[]);
  }
};
